import { useCallback } from 'react'

import {
  AlertType,
  useNotifications
} from '@app/common/services/Notifications/NotificationsProvider'
import { CourtCaseState } from '@app/graphql/types'
import { useTransitionCourtCaseMutation } from '@app/queries/CourtCases/TransitionCourtCase.queries'

export const useCourtCaseTransition = () => {
  const { pushNotification } = useNotifications()

  const [transitionMutation] = useTransitionCourtCaseMutation({
    onError(error) {
      pushNotification({
        type: AlertType.error,
        message: error.message
      })
    }
  })

  const transitionToOpenedByLawyer = useCallback(
    async (courtCaseUuid: string) => {
      await transitionMutation({
        variables: {
          input: {
            courtCaseUuid,
            newState: CourtCaseState.ClientFileOpenedByLawyer
          }
        }
      })
    },
    [transitionMutation]
  )

  return {
    transitionToOpenedByLawyer
  }
}
